__webpack_require__.p = "/energiberegner/_next/";